import { Skeleton } from '../../atoms';

type ProductPeekViewSkeletonProps = {
  showProductHeader?: boolean;
};

const metricSkeletons = Array.from({ length: 8 }, (_, index) => (
  <div key={`product-peek-view-metric-${index}`} className="space-y-2">
    <Skeleton className="h-3 w-20" />
    <Skeleton className="h-4 w-24" />
  </div>
));

export const ProductPeekViewSkeleton = ({
  showProductHeader = false,
}: ProductPeekViewSkeletonProps) => (
  <div className="flex flex-col gap-3">
    {showProductHeader ? (
      <div className="flex items-center gap-3">
        <Skeleton className="h-12 w-12" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
    ) : null}
    <div className="grid grid-cols-2 gap-x-4 gap-y-3">
      <div className="col-span-2">
        <Skeleton className="h-12 w-full" />
      </div>
      {metricSkeletons}
    </div>
  </div>
);
